import { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { navigation } from '../content/tr';
import { siteConfig } from '../config/siteConfig';
import BrandMark from './BrandMark';

export default function Layout({ children }) {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <>
      <a className="skip-link" href="#main-content">
        Ana içeriğe geç
      </a>
      <header className="site-header">
        <div className="shell header-inner">
          <BrandMark compact />
          <button
            className="menu-toggle"
            type="button"
            aria-expanded={menuOpen}
            aria-controls="site-navigation"
            onClick={() => setMenuOpen((current) => !current)}
          >
            <span aria-hidden="true">{menuOpen ? '×' : '☰'}</span>
            <span className="sr-only">Menüyü aç veya kapat</span>
          </button>
          <nav
            id="site-navigation"
            className={'site-navigation' + (menuOpen ? ' is-open' : '')}
            aria-label="Ana menü"
          >
            {navigation.map((item) =>
              item.to.includes('#') ? (
                <a
                  key={item.to}
                  href={item.to}
                  onClick={() => setMenuOpen(false)}
                >
                  {item.label}
                </a>
              ) : (
                <NavLink
                  key={item.to}
                  to={item.to}
                  onClick={() => setMenuOpen(false)}
                >
                  {item.label}
                </NavLink>
              )
            )}
            <Link
              className="header-cta"
              to="/delete-account"
              onClick={() => setMenuOpen(false)}
            >
              Hesap işlemleri
            </Link>
          </nav>
        </div>
      </header>
      <main id="main-content">{children}</main>
      <footer className="site-footer">
        <div className="shell footer-grid">
          <div>
            <BrandMark compact />
            <p>
              Gezi planlamayı, keşfetmeyi ve rotada kalmayı daha kolay hâle
              getiren akıllı yol arkadaşı.
            </p>
          </div>
          <div>
            <h2>Yasal</h2>
            <Link to="/privacy">Gizlilik Politikası</Link>
            <Link to="/terms">Kullanım Koşulları</Link>
            <Link to="/delete-account">Hesap ve Veri Silme</Link>
          </div>
          <div>
            <h2>Destek</h2>
            <Link to="/contact">İletişim formu</Link>
            {siteConfig.supportEmail && (
              <a href={'mailto:' + siteConfig.supportEmail}>
                {siteConfig.supportEmail}
              </a>
            )}
            {siteConfig.socialLinks.map((social) => (
              <a
                key={social.name}
                href={social.url}
                target="_blank"
                rel="noreferrer"
              >
                {social.name}
              </a>
            ))}
          </div>
        </div>
        <div className="shell footer-bottom">
          <span>© 2026 Tripzy. Tüm hakları saklıdır.</span>
          <span>Türkiye’de geliştirildi.</span>
        </div>
      </footer>
    </>
  );
}
